import { useState } from "react";

import { DEFAULT_LOG_FILTERS, LogsWorkspace } from "../logs";
import type { LogFilters, TraceApi } from "../logs";

/** A user's calls: the shared trace list/timeline, scoped to one user id. */
export function UserLogsTab({
  api,
  userId,
  wide,
}: {
  api: TraceApi;
  userId: string;
  wide: boolean;
}) {
  const [filters, setFilters] = useState<LogFilters>({
    ...DEFAULT_LOG_FILTERS,
    userId,
    range: "24h",
  });
  const [openId, setOpenId] = useState<string | null>(null);
  return (
    <LogsWorkspace
      api={api}
      wide={wide}
      filters={filters}
      onFiltersChange={(next) => {
        setFilters({ ...next, userId });
      }}
      openId={openId}
      onOpen={setOpenId}
      onClose={() => {
        setOpenId(null);
      }}
      hideUserFilter
    />
  );
}
